/**
 * Application bootstrap file
 *
 * This file serves as the actual entry point of the application.
 * It ensures that Font Awesome is loaded before any React components
 * to prevent icons from appearing as squares initially.
 */

// First, import and initialize Font Awesome
import './utils/initFA';

// Import other necessary libraries
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'simplebar-react/dist/simplebar.min.css';

// Then, import the main app initialization
import { initializeApp } from './bootstrap';

// Initialize the application after Font Awesome is loaded
initializeApp();
